import DateAdapter from '@/utils/DateAdapter'
import CreateEvaluacionAnualDto from '../../domain/CreateEvaluacionAnualDto'
import { VUETIFY_DATE_FORMAT } from '@/const'

class CreateEvaluacionAnualAdapter {
  static toDto({ idPersonalEvaluador, idSupervisor, estatus, fecha, reactivos, tipoEvaluacion }) {
    return CreateEvaluacionAnualDto.create({
      fk_idPersonalEvaluador: idPersonalEvaluador,
      fk_idSupervisor: idSupervisor != null ? Number(idSupervisor) : null,
      fecha: new DateAdapter(fecha, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fk_idCatEstatusEvaluacion: estatus,
      cumplimientoFunciones: reactivos.map((reactivo) => ({
        calificacion: String(reactivo.calificacion),
        fk_idDescripcionCriterio: reactivo.id,
      })),
      fk_idCatTipoEvaluacion: tipoEvaluacion,
    })
  }
}

export default CreateEvaluacionAnualAdapter
